<div class="a-titulo">Kunaq</div>
<form [formGroup]="group">
    <div class="a-w1-row">
        <p-floatlabel class="a-w4" variant="on">
            <p-multiSelect [options]="listaCliente" virtualScroll="true" formControlName="importador"
                styleClass="w-full" showClear="true"></p-multiSelect>
            <label for="importador">Importador</label>
        </p-floatlabel>
        <p-floatlabel class="a-w6" variant="on">
            <p-datepicker appendTo="body" formControlName="desde" iconDisplay="input" showIcon="true"
                styleClass="w-full" dateFormat="dd/mm/yy"></p-datepicker>
            <label for="desde">Desde</label>
        </p-floatlabel>
        <p-floatlabel class="a-w6" variant="on">
            <p-datepicker appendTo="body" formControlName="hasta" iconDisplay="input" showIcon="true"
                styleClass="w-full" dateFormat="dd/mm/yy"></p-datepicker>
            <label for="hasta">Hasta</label>
        </p-floatlabel>
        <div class="flex flex-wrap gap-4 align-items-center">
            <div class="flex items-center">
                <p-radiobutton value="1" inputId="kunaq" formControlName="tipo" (onClick)="ngChangeTypeReport()" />
                <label for="kunaq" class="ml-2">Kunaq</label>
            </div>

            <div class="flex items-center">
                <p-radiobutton value="2" inputId="gerencial" formControlName="tipo" (onClick)="ngChangeTypeReport()" />
                <label for="gerencial" class="ml-2">Reporte Gerencial</label>
            </div>
        </div>
        <p-button icon="pi pi-search" label="Buscar" variant="outlined" (onClick)="search()"></p-button>
        <p-button icon="pi pi-download" label="Descargar" variant="outlined" (onClick)="export()"
            [disabled]="datatable.length === 0"></p-button>
        <p-button icon="pi pi-sync" label="Sincronizar" variant="outlined" (onClick)="syncKunaq()"></p-button>
    </div>
</form>
<app-datatable [dataTable]="datatable" [metadataTable]="metadatatable"></app-datatable>